import {
  fetchAllTransactionsFail,
  fetchAllTransactionsPending,
  fetchAllTransactionsSuccess,
  fetchTransactionsFail,
  fetchTransactionsPending,
  fetchTransactionsSuccess,
} from "../Slices/transactionsSlice";

export const fetchTransactions = (AuthToken, apiToken) => async (dispatch) => {
  dispatch(fetchTransactionsPending());
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASEURL}/transaction/list/5`,
      {
        method: "GET",
        headers: new Headers({
          "Content-type": "application/json",
          "x-api-key": process.env.REACT_APP_APIKEY,
          // "x-api-key": "6aerc34c54",
          // Authorization: "Bearer " + AuthToken,
        }),
      }
    );
    const fetchedTransactions = await response.json();
    dispatch(fetchTransactionsSuccess(fetchedTransactions.data));
  } catch (error) {
    dispatch(fetchTransactionsFail(error.message));
  }
};

export const fetchAllTransactions = (AuthToken) => async (dispatch) => {
  console.log("Transaction.....");
  dispatch(fetchAllTransactionsPending());
  if (AuthToken) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASEURL}/api/v1/transactions/getAll`,
      {
        method: "GET",
        headers: new Headers({
          "Content-type": "application/json",
          "x-api-key": "6aerc34c54",
          // apiToken: apiToken,
          // token: AuthToken,
          Authorization: "Bearer " + AuthToken,
        }),
      }
    );
    const fetchedTransactions = await response.json();
    dispatch(fetchAllTransactionsSuccess(fetchedTransactions));
    console.log("Transaction", fetchedTransactions);
  } catch (error) {
    dispatch(fetchAllTransactionsFail(error));
    console.log("Trans Error", error);
  }
  } else {
    return;
  }
};

// export const CreateTransaction = (
//   wallet_uuid,
//   amount,
//   token_uuid,
//   apiToken,
//   AuthToken
// ) => {
//   return async (dispatch) => {
//     dispatch(createTransactionPending());
//     const response = await fetch(
//       `${process.env.REACT_APP_BASEURL}/transaction/`,
//       {
//         method: "POST",
//         body: JSON.stringify({
//           wallet_uuid,
//           amount,
//           token_uuid,
//         }),
//         headers: new Headers({
//           "Content-type": "application/json",
//           apiKey: process.env.REACT_APP_APIKEY,
//           apiToken: apiToken,
//           Authorization: "Bearer " + AuthToken,
//         }),
//       }
//     );

//     if (!response.ok) {
//       const error = await response.json();
//       dispatch(createTransactionFail(error));
//       // console.log(error);
//     }
//     const res = await response.json();
//     // console.log(res);
//     dispatch(createTransactionSuccess(res.data));
//   };
// };
